import { css } from 'styled-components';

export const SemanticUiOverride = () => css`
	body {
		.ui.dropdown,
		.ui.selection.dropdown,
		.ui.search.selection.dropdown {
			padding: 0px 10px;
			min-height: 35px;
			display: flex;
			align-items: center;

			> input.search {
				padding: 10px;
			}

			> .text {
				padding-right: 20px;
				font-size: 12px;
				line-height: initial;
			}

			> .icon,
			.dropdown.icon {
				font-size: 14px;
				padding: 8px;
				display: flex;
				align-items: center;
				font-family: Icons;
			}

			.menu > {
				.item {
					font-size: 16px;
				}
			}
		}
		,
		.ui.top.left.popup.transition.visible {
			padding: 2px 7px;
		}
		.ui.top.left.popup.transition.visible label {
			margin-top: 8px;
		}
	}
`;
